import { FormioTranslation } from "../interfaces/forms/formio-translation";

export const texts: FormioTranslation = {
	es: {
		'Submit': 'Enviar',
		'Draft': 'Borrador',
		'Add Another': 'Añadir',
		'Cancel': 'Cancelar',
		'Delete': 'Borrar',
		'Signature': 'Firma',
		'Drop files to attach,': 'Arrastrar ficheros para adjuntarlos,',
		'or': 'o',
		'browse': 'buscar',
		'Browse Files': 'Buscar ficheros',
		'No storage has been set for this field. File uploads are disabled until storage is set up': 'No se ha configurado ningún almacenamiento para este campo. Las cargas de archivos están deshabilitadas hasta que se configura el almacenamiento',
		'File Name': 'Nombre del archivo',
		'Size': 'Tamaño',
		'use camera': 'utilizar la cámara',
		'Type to search': 'Escribe para buscar',
		'No results found': 'No se han encontrado resultados',
		'No choices to choose from': 'No hay opciones para elegir',
		'Press Enter to add': 'Presiona intro para añadir',
		'Only unique values can be added': 'Solo pueden añadirse valores únicos',
		'Sign above': 'Firma encima',
		'Key': 'Clave',
		'Value': 'Valor',
		'Click to set value': 'Presiona para introducir un valor',
		'Save': 'Guardar',
		'Sun': 'Dom',
		'Mon': 'Lun',
		'Tue': 'Mar',
		'Wed': 'Mié',
		'Thu': 'Jue',
		'Fri': 'Vie',
		'Sat': 'Sáb',
		'Sunday': 'Domingo',
		'Monday': 'Lunes',
		'Tuesday': 'Martes',
		'Wednesday': 'Miércoles',
		'Thursday': 'Jueves',
		'Friday': 'Viernes',
		'Saturday': 'Sábado',
		'Jan': 'Ene',
		'Feb': 'Feb',
		'Mar': 'Mar',
		'Apr': 'Abr',
		'Jun': 'Jun',
		'Jul': 'Jul',
		'Aug': 'Ago',
		'Sep': 'Sep',
		'Oct': 'Oct',
		'Nov': 'Nov',
		'Dec': 'Dic',
		unsavedRowsError: 'Por favor, guarde todas las filas antes de proceder.',
		invalidRowsError: 'Por favor, corrija los errores en las filas antes de proceder.',
		invalidRowError: 'Fila no válida. Por favor, corríjala o bórrela.',
		alertMessageWithLabel: '{{label}}: {{message}}',
		alertMessage: '{{message}}',
		complete: 'Respuesta guardada.',
		error: 'Por favor, solucione los siguientes errores para poder continuar.',
		errorListHotkey: 'Presione Ctrl + Alt + X para volver a la lista de errores',
		errorsListNavigationMessage: 'Clique para navegar al campo con el siguiente error.',
		submitError: '',
		required: '{{field}} es obligatorio',
		unique: '{{field}} debe ser único',
		array: '{{field}} debe ser una lista de elementos',
		array_nonempty: '{{field}} no puede ser una lista vacía',
		nonarray: '{{field}} no puede ser una lista de elementos',
		select: '{{field}} contiene una selección no válida',
		pattern: '{{field}} no sigue el patrón {{pattern}}',
		minLength: '{{field}} debe tener al menos {{length}} caracteres.',
		maxLength: '{{field}} no puede tener más de {{length}} caracteres.',
		minWords: '{{field}} debe tener al menos {{length}} palabras.',
		maxWords: '{{field}} no puede tener más de {{length}} palabras.',
		min: '{{field}} no puede ser menor que {{min}}.',
		max: '{{field}} no puede ser mayor que {{max}}.',
		maxDate: '{{field}} no debe ser una fecha posterior a {{- maxDate}}',
		minDate: '{{field}} no debe ser una fecha anterior a {{- minDate}}',
		maxYear: '{{field}} no debe ser un año mayor que {{maxYear}}',
		minYear: '{{field}} no debe ser un año menor que {{minYear}}',
		invalid_email: '{{field}} debe ser una dirección de email válida.',
		invalid_url: '{{field}} mdebe ser una URL válida.',
		invalid_regex: '{{field}} no sigue el patrón {{regex}}.',
		invalid_date: '{{field}} no es una fecha válida.',
		invalid_day: '{{field}} no es un día válido.',
		mask: '{{field}} no encaja con la máscara.',
		valueIsNotAvailable: '{{ field }} no es un valor válido.',
		stripe: '{{stripe}}',
		month: 'Mes',
		day: 'Día',
		year: 'Año',
		january: 'Enero',
		february: 'Febrero',
		march: 'Marzo',
		april: 'Abril',
		may: 'Mayo',
		june: 'Junio',
		july: 'Julio',
		august: 'Agosto',
		september: 'Septiembre',
		october: 'Octubre',
		november: 'Noviembre',
		december: 'Diciembre',
		next: 'Siguiente',
		previous: 'Anterior',
		cancel: 'Cancelar',
		submit: 'Guardar',
		confirmCancel: '¿Está seguro de que quiere cancelar?',
		saveDraftInstanceError: 'No es posible guardar borradores porque no se encuentra una instancia válida',
		saveDraftAuthError: 'No puede guardar borradores hasta que esté autenticado.',
		restoreDraftInstanceError: 'No es posible restaurar un borrador porque no se encuentra una instancia válida',
		time: 'Hora inválida',
		cancelButtonAriaLabel: 'Botón de cancelar. Presione para resetear el formulario.',
		previousButtonAriaLabel: 'Botón Anterior. Presione para ir a la anterior pestaña',
		nextButtonAriaLabel: 'Botón siguiente. Presione para ir a la siguiente pestaña',
		submitButtonAriaLabel: 'Botón de finalizar. Presione para enviar su respuesta.'
	}
};